// extracted by mini-css-extract-plugin
export default {"referral-widget":"Qq","referral-page":"Rq","label":"Sq","subHed":"Tq","profile-container":"Uq","referral-container":"Vq","referral-header":"Wq","shareMethodRow":"Xq","shareMethod":"Yq","active":"Zq","referral-stat":"ar","blockwrapper":"br","referralLink":"cr","bold":"er","semibold":"fr","shareAgainButton":"gr","policy":"hr","narrowWrapper":"ir"};
    if(module.hot) {
      // 1738064238126
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  